import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import authToken from "./../token/Token";
import { contactusApi } from "./../API/api";

const Contact = ({ match }) => {
  const [phoneNum, setPhoneNum] = useState("");
  const [emails, setEmails] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchContactusData = async () => {
      try {
        const response = await axios.get(`${contactusApi}/${match.params.id}`);

        const contactusData = response.data.data;

        setPhoneNum(contactusData.phone_num);
        setEmails(contactusData.email);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    fetchContactusData();
  }, [match.params.id]);

  const handleCloseModal = () => {
    setShowModal(false);
    history.push("/components/footer");
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("phone_num", phoneNum);
    formData.append("email", emails);
    formData.append("_method", "PUT");

    try {
      await axios.post(`${contactusApi}/${match.params.id}`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "emails-Type": "multipart/form-data",
        },
      });

      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section>
      <div className="container wrap-section-1">
        <div className="row mx-3">
          <div className="col-lg">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <Form>
                <Form.Group className="mb-3" controlId="phoneNum">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={phoneNum}
                    onChange={(e) => setPhoneNum(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="emails">
                  <Form.Label>Edit Email</Form.Label>
                  <Form.Control
                    type="text"
                    value={emails}
                    onChange={(e) => setEmails(e.target.value)}
                  />
                </Form.Group>

                <Button variant="warning" onClick={handleSubmit}>
                  Simpan
                </Button>

                <Modal show={showModal} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Data Success Update</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Your data has been successfully updated!
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="warning" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
